/**
 * スプリント列フィルター用の共通ユーティリティ
 * Project Plan / WBS Search 両方で使用
 */
import { SprintDetail, FilterSortOrder } from '../../../../lib/functions/sprint'

/** フィルター用ラベル生成: [status] (teamName) name */
export const getSprintFilterLabel = (option: SprintDetail): string =>
  `[${option.status}] (${option.teamName ?? ''}) ${option.name}`

/** スプリントをフィルター用にソート（ステータス→チーム→num）。sprintMaster指定時はteamNameを補完 */
export const sortSprintsForFilter = (
  sprints: SprintDetail[],
  sprintMaster?: SprintDetail[]
): SprintDetail[] => {
  const enriched = sprintMaster
    ? sprints.map(opt => {
        const master = sprintMaster.find(s => s.uuid === opt.uuid)
        return master ? { ...opt, teamName: master.teamName } : opt
      })
    : sprints
  return [...enriched].sort((a, b) => {
    if (a.status === b.status) {
      if (a.teamName === b.teamName) {
        return a.num - b.num
      }
      return (a.teamName ?? '') > (b.teamName ?? '') ? 1 : -1
    }
    return FilterSortOrder.indexOf(a.status) - FilterSortOrder.indexOf(b.status)
  })
}
